module.exports = __webpack_public_path__ + "static/media/yan.fcc29531.jpg";